import { Transforms, Path, Editor, Point, Range, Node, Element as SlateElement } from 'vendor/slate'
import { ReactEditor } from 'vendor/slate-react'
import { ELEMENT_TYPES } from 'cg/components/documents/editor/slate/types'
import { v4 as uuidv4 } from 'uuid'

const insertQuote = (editor, path) => {
  const quote = {
    type: ELEMENT_TYPES.quote,
    children: [
      {
        type: ELEMENT_TYPES.quote_content,
        parent: { type: ELEMENT_TYPES.quote },
        children: [
          {
            type: ELEMENT_TYPES.default,
            parent: { type: ELEMENT_TYPES.quote_content },
            children: [{ uuid: uuidv4(), text: '', parent: { type: ELEMENT_TYPES.default } }]
          }
        ]
      }
    ]
  }

  Transforms.insertNodes(editor, quote, { at: path, select: true })
  ReactEditor.focus(editor)
}

const withQuotes = editor => {
  const { deleteBackward, normalizeNode } = editor

  editor.normalizeNode = entry => {
    const [node, path] = entry

    if (node.type === ELEMENT_TYPES.quote) {
      const firstChild = node.children[0]
      if (!firstChild || firstChild.type !== ELEMENT_TYPES.quote_content) {
        const missing_quote_content_children = []
        for (const [child] of Node.children(editor, path)) {
          for (const [element] of Node.elements(child)) {
            if (element.type !== ELEMENT_TYPES.quote_content) {
              let text = ''
              for (const [original] of Node.texts(child)) {
                text += original?.text || ''
              }

              missing_quote_content_children.push({
                type: element.type,
                parent: { type: ELEMENT_TYPES.quote_content },
                children: [{ uuid: uuidv4(), text, parent: { type: element.type } }]
              })
            }
          }
        }

        if (missing_quote_content_children.length > 0) {
          Editor.withoutNormalizing(editor, () => {
            Transforms.removeNodes(editor, { at: path })
            Transforms.insertNodes(
              editor,
              {
                type: ELEMENT_TYPES.quote,
                children: [
                  {
                    type: ELEMENT_TYPES.quote_content,
                    parent: { type: ELEMENT_TYPES.quote },
                    children: missing_quote_content_children
                  }
                ]
              },
              { at: path, select: true }
            )
          })
          ReactEditor.focus(editor)
          return
        }
      }
    }

    normalizeNode(entry)
  }

  editor.deleteBackward = unit => {
    const { selection } = editor

    if (selection && Range.isCollapsed(selection)) {
      const { anchor } = selection
      const [match] = Editor.nodes(editor, {
        at: selection,
        mode: 'lowest',
        match: n => !Editor.isEditor(n) && [ELEMENT_TYPES.quote_content].includes(n.parent && n.parent.type)
      })

      if (match) {
        const [, path] = match
        const start = Editor.start(editor, Path.parent(path))

        if (Point.equals(anchor, start)) {
          return
        }
      }
    }

    deleteBackward(unit)
  }

  return editor
}
export { insertQuote, withQuotes }
